import { cloneDeep } from 'lodash';
import { IProductNavigation, IProductSideNav } from '../interfaces';

/**
 * @author Jesse Rogers <jesse.rogers@adaptiva.com>
 * @description Manages product header links and sidenavs by product code.
 * 	Provided statically through `ProductNavigationModule`
 * @see ProductNavigationModule
 */
export class ProductNavigationService {

	private _productNavigationMap: Map<string, IProductNavigation> = new Map();

	private _productSideNavMap: Map<string, IProductSideNav> = new Map();

	constructor(
		_products: IProductNavigation[],
		_sidenavs?: IProductSideNav[]
	) {
		this.addProductNavigations(..._products);
		if (_sidenavs?.length) this.addProductSideNavs(..._sidenavs);
	}

	public addProductNavigations(..._products: IProductNavigation[]): void {
		_products.forEach(_product => {
			this._addProduct(_product);
		});
	}

	public addProductSideNavs(..._sidenavs: IProductSideNav[]): void {
		_sidenavs.forEach(_sidenav => {
			this._productSideNavMap.set(_sidenav.productName.toLowerCase(), _sidenav);
		});
	}

	public getAllProductNavigations(): IProductNavigation[] {
		return Array.from(this._productNavigationMap.values()).map(n => cloneDeep(n));
	}

	public getProductNavigation(_productName: string): IProductNavigation {
		return this._productNavigationMap.get(_productName?.toLowerCase());
	}

	public getProductSideNav(_productName: string): IProductSideNav {
		_productName = _productName?.toLowerCase() || '';

		if (!_productName || !this._productSideNavMap.has(_productName))
			return null;

		return cloneDeep(this._productSideNavMap.get(_productName));
	}

	private _addProduct(_product: IProductNavigation): void {
		this._productNavigationMap.set(_product.productName.toLowerCase(), _product);

		if (_product.sidenav)
			this._productSideNavMap.set(_product.productName.toLowerCase(), _product.sidenav);

		if (_product.children?.length) {
			_product.children.forEach(_child => {
				this._productSideNavMap.set(_child.productName.toLowerCase(), _child.sidenav);
			});
		}
	}

}
